import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import AdminListRole from "./AdminListRole";
function AdminRoleDropdown({ roles, selectedRoles, handleRolesChange, setSelectedRoles }) {
    return (
        <>
            <Dropdown className="d-inline-block">
                {/* variant="secondary" */}
                <Dropdown.Toggle className="p-0" id="roleFilterDropdown">
                    Role
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <form>
                        {roles.map((role) => (
                            <AdminListRole selectedRoles={selectedRoles} key={role.id} role={role.label} id={role.id} onClick={handleRolesChange} />
                        ))}
                    </form>
                    <div>
                        <input type="button" className="btn btn-link" value="Clear All" onClick={() => setSelectedRoles([])} />
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}

export default AdminRoleDropdown;